import { render, staticRenderFns } from "./ContactParticipantModal.vue?vue&type=template&id=a4d57736"
import script from "./ContactParticipantModal.vue?vue&type=script&lang=ts"
export * from "./ContactParticipantModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports